<template>
	<div class="panel-body">
		<!-- static-fields -->
		<div class="user-fields m-l m-t text-white clearfix">
			<!-- profile-image -->
			<div class="field m-b-md">
				<div class="profile-img">
					<img
						@error="setDefaultAvatar('.profile-img > img')"
						:src="user.photo || '/images/users/avatar.png'"
						alt="User photo"
					>
				</div>
			</div>
			<!-- /.profile-image -->
			<!-- username -->
			<div class="field m-b-md">
				<label for="username">Username</label>
				<p id="username">{{ user.username || "USERNAME" | upperCase }}</p>
			</div>
			<!-- /.username -->
			<!-- email -->
			<div class="field m-b-md">
				<label for="email">Email</label>
				<p id="email">{{ user.email || "username@email.com" | upperCase }}</p>
			</div>
			<!-- /.email -->

			<!-- birthdate -->
			<div class="field m-b-md">
				<label for="birth-date">Birth Date</label>
				<p id="birth-date">{{ birthDate | replace("-", "/") }}</p>
			</div>
			<!-- /.birthdate -->
			<!-- location -->
			<div class="field m-b-md">
				<label for="location">Location</label>
				<p id="location">{{ countries[user.location] }}</p>
			</div>
			<!-- /.location -->
		</div>
		<!-- /.static-fields -->
	</div>
</template>

<script>
import { userMixin, helpers } from "../../util/mixins";
import { getUserData, setUserData } from "../../util/helpers.js";
export default {
	name: "UserAccountInformation",
	mixins: [userMixin, helpers],
	data() {
		return {
			user: getUserData() || {},
			countries: nzxt.countries
		};
	},
	computed: {
		birthDate() {
			if (this.user.dob == "null" || !this.user.dob) {
				return "00/00/00";
			}

			return this.user.dob;
		}
	},
	created() {
		this.getCurrentUserData();
	},
	methods: {
		getCurrentUserData() {
			this.getCurrentUser()
				.then(user => {
					this.user = user;
					const updatedUserData = _.extend(
						getUserData(),
						this.trimObjValues(user)
					);
					setUserData(updatedUserData);
					EventBus.$emit("user-logged-in", updatedUserData);
					this.$store.dispatch("saveUserData", updatedUserData);
				})
				.catch(error => {});
		}
	}
};
</script>
